<div class="table-container">
<table mat-table [dataSource]="dataSource" matSort>

  <!--<ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{ 'pages.addresses.table.name' | translate }} </th>
      <td mat-cell *matCellDef="let address">
          {{ 'general.salutations.'+address.salutation | translate }} {{ address.firstName }} {{ address.lastName }}
      </td>
  </ng-container>-->


  <ng-container matColumnDef="projektnr">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.projektverwaltung.table.projektnr' | translate }} </th>
    <td mat-cell *matCellDef="let projekt"> {{projekt.nummer }} </td>
  </ng-container>

  <ng-container matColumnDef="projektname">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'pages.projektverwaltung.table.projektname' | translate }} </th>
    <td mat-cell *matCellDef="let projekt"> {{projekt.name }} </td>
  </ng-container>

  <ng-container matColumnDef="projektstart">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.projektverwaltung.table.projektstart' | translate }} </th>
    <td mat-cell *matCellDef="let projekt"> {{projekt.start | date:'dd.MM.yyyy' }} </td>
  </ng-container>

  <ng-container matColumnDef="projektende" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.projektverwaltung.table.projektende' | translate }} </th>
    <td mat-cell *matCellDef="let projekt"> {{projekt.ende | date:'dd.MM.yyyy' }} </td>
  </ng-container>



  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let projekt">
      <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button mat-menu-item >{{ 'pages.projektverwaltung.actions.archiv' | translate }}</button>
        <button mat-menu-item (click)="editProjekt.emit(projekt)">{{ 'pages.projektverwaltung.actions.edit' | translate }}</button>
        <button mat-menu-item (click)="deleteProjekt.emit(projekt.id)" >{{ 'pages.projektverwaltung.actions.delete' | translate }}</button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let myRowData; columns: displayedColumns"></tr>
</table>
</div>
